/* ============================================================
   faq-altura.js — as respostas do FAQ aparecem inteiras

   O bloco do FAQ abre cada resposta assim:

       answer.style.maxHeight = inner.scrollHeight + 32 + 'px';

   A medida é tirada no instante do clique, antes de o texto
   assentar na largura final. No telemóvel sai curta e a última
   linha fica escondida — lia-se "…najdete na" e o resto
   desaparecia. Este ficheiro volta a medir depois, com a
   largura já certa, e corrige a altura.

   DUAS ARMADILHAS, ambas custaram horas. Quem mexer aqui leia
   isto primeiro:

   1) NÃO se resolve por CSS. Uma regra
      `.faq-answer { max-height: 0 !important }` numa folha de
      estilo ganha ao inline do bloco e tranca a resposta
      fechada para sempre — deixa de abrir de todo.

   2) Enquanto a transição `max-height` está a decorrer, o valor
      animado tem precedência sobre TUDO, incluindo !important
      escrito no próprio elemento. Verificado ao vivo: com
      style="max-height: 64px !important" no elemento, o valor
      calculado era 0px; bastou desligar a transição para
      passar a 64px. É por isso que aqui em baixo a transição
      é desligada antes de escrever e religada a seguir.

   O truque das três etapas (desligar / fixar o zero / religar
   e abrir) mantém a animação: a resposta continua a deslizar,
   só que agora até à altura verdadeira.

   Vale em qualquer largura — telemóvel, tablet ou computador.
   ============================================================ */

(function () {
  function abre(resposta, texto) {
    var altura = texto.scrollHeight || texto.getBoundingClientRect().height;
    if (!altura) return;

    /* 1. sem animação, para a escrita passar (ver armadilha 2) */
    resposta.style.transition = 'none';
    resposta.style.maxHeight = '0px';

    /* 2. obriga o navegador a assentar o zero antes de animar */
    void resposta.offsetHeight;

    /* 3. animação de volta, e aí sim a altura verdadeira */
    resposta.style.transition = '';
    resposta.style.maxHeight = altura + 40 + 'px';
  }

  function ajusta() {
    var itens = document.querySelectorAll('.faq-item');

    for (var i = 0; i < itens.length; i++) {
      var item = itens[i];
      var resposta = item.querySelector('.faq-answer');
      var texto = item.querySelector('.faq-answer-inner');
      if (!resposta || !texto) continue;

      if (item.classList.contains('faq-open')) {
        abre(resposta, texto);
      } else {
        /* Fechar é com o bloco. Aqui só se limpa o que ficou. */
        resposta.style.transition = '';
      }
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.faq-btn')) return;

    /* Depois de o script do bloco ter feito o seu trabalho. */
    setTimeout(ajusta, 0);
    /* E outra vez, para o caso de as letras só chegarem depois. */
    setTimeout(ajusta, 600);
  });

  /* Rodar o telemóvel muda a largura, e com ela o número de
     linhas do texto que está aberto. */
  var espera;
  window.addEventListener('resize', function () {
    clearTimeout(espera);
    espera = setTimeout(ajusta, 150);
  });
})();
